import { CARD_TYPES } from '@nike/ciclp-redux-app';

export const isVideoSlide = slide => slide?.containerType === CARD_TYPES.VIDEO;
